import { render, staticRenderFns } from "./FiscalTaxParameterSpecialTreatmentForm.vue?vue&type=template&id=0d74d55a&"
import script from "./FiscalTaxParameterSpecialTreatmentForm.vue?vue&type=script&lang=js&"
export * from "./FiscalTaxParameterSpecialTreatmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d74d55a')) {
      api.createRecord('0d74d55a', component.options)
    } else {
      api.reload('0d74d55a', component.options)
    }
    module.hot.accept("./FiscalTaxParameterSpecialTreatmentForm.vue?vue&type=template&id=0d74d55a&", function () {
      api.rerender('0d74d55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/FiscalTaxParameterSpecialTreatmentForm.vue"
export default component.exports